import React from 'react';
import styles from './LandingPageHeader.module.scss';
import logo from '../../resources/images/scholastic-logo.png';

const LandingPageHeader = () => (
  <div className={styles.LandingPageHeader} data-testid="LandingPageHeader">
    <div className={styles.image}>
      <img src={logo} alt="logo" className={styles.schlLogo} />
    </div>

  </div>
);

export default LandingPageHeader;
